import { render, staticRenderFns } from "./ChordProTextArea.vue?vue&type=template&id=3ca01187&scoped=true"
import script from "./ChordProTextArea.vue?vue&type=script&lang=ts"
export * from "./ChordProTextArea.vue?vue&type=script&lang=ts"
import style0 from "./ChordProTextArea.vue?vue&type=style&index=0&id=3ca01187&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca01187",
  null
  
)

export default component.exports